import { makeRequest, toCorrectFormDataValue, } from '@/js/libs/api';
import * as Types from './types';
import { encodeBody, fromDateType as fromDate, toDateType as toDate, fromDateTimeType as fromDateTime, toDateTimeUnixType as toDateTime, } from '@/js/libs/api-helpers';
export { fromDate, toDate, fromDateTime, toDateTime };
/** Returns available translations for given language and namespace */ export const getTranslations = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-translate/translations';
    const pathInternal = '/api/translations';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.keyFilter : (params.keyFilter ?? queryDefaults?.['keyFilter']);
        if (value !== undefined) {
            urlParams.append('keyFilter', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.keyValueFilter : (params.keyValueFilter ?? queryDefaults?.['keyValueFilter']);
        if (value !== undefined) {
            urlParams.append('keyValueFilter', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.namespace : (params.namespace ?? queryDefaults?.['namespace']);
        if (value !== undefined) {
            urlParams.append('namespace', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.missing : (params.missing ?? queryDefaults?.['missing']);
        if (value !== undefined) {
            urlParams.append('missing', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.language : (params.language ?? queryDefaults?.['language']);
        if (value !== undefined) {
            urlParams.append('language', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getTranslations.paramsOrder = [{ type: 'parameters' }];
/** Deletes translations by IDs */ export const deleteTranslations = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.ids === undefined) {
        throw new Error('Missing required parameter: ids');
    }
    const path = '/api/ws-translate/translations';
    const pathInternal = '/api/translations';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.ids !== undefined) {
        params.ids.forEach((item) => urlParams.append('ids', item.toString()));
    }
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteTranslations.paramsOrder = [{ type: 'parameters' }];
/** Returns available translations for selected keys by given language and namespace */ export const getTranslationsByKeys = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.keys === undefined) {
        throw new Error('Missing required body: keys');
    }
    const path = '/api/ws-translate/translations/by-keys';
    const pathInternal = '/api/translations/by-keys';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.keys !== undefined) {
        body = params.keys;
    }
    {
        const value = queryDefaults === false ? params.language : (params.language ?? queryDefaults?.['language']);
        if (value !== undefined) {
            urlParams.append('language', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.namespace : (params.namespace ?? queryDefaults?.['namespace']);
        if (value !== undefined) {
            urlParams.append('namespace', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getTranslationsByKeys.paramsOrder = [{ type: 'body', paramName: 'keys' }, { type: 'parameters' }];
/** Returns available translations for given language and namespace */ export const getAggregatedTranslations = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-translate/translations-aggregated';
    const pathInternal = '/api/translations-aggregated';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.language : (params.language ?? queryDefaults?.['language']);
        if (value !== undefined) {
            urlParams.append('language', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.namespace : (params.namespace ?? queryDefaults?.['namespace']);
        if (value !== undefined) {
            urlParams.append('namespace', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAggregatedTranslations.paramsOrder = [{ type: 'parameters' }];
/** Generate missing translations with AI */ export const getGeneratedTranslations = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-translate/translation/{id}/generate'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/translation/{id}/generate'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getGeneratedTranslations.paramsOrder = [{ type: 'parameters' }];
/** Update translation by id */ export const updateTranslation = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-translate/translation/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/translation/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateTranslation.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** Delete translation by id */ export const deleteTranslation = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-translate/translation/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/translation/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteTranslation.paramsOrder = [{ type: 'parameters' }];
/** Clone translation by id */ export const cloneTranslation = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-translate/translation/{id}/clone'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/translation/{id}/clone'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
cloneTranslation.paramsOrder = [{ type: 'parameters' }];
export const addTranslation = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.translation === undefined) {
        throw new Error('Missing required body: translation');
    }
    const path = '/api/ws-translate/translation';
    const pathInternal = '/api/translation';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.translation !== undefined) {
        body = params.translation;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
addTranslation.paramsOrder = [{ type: 'body', paramName: 'translation' }];
export const addMissingTranslation = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.translation === undefined) {
        throw new Error('Missing required body: translation');
    }
    const path = '/api/ws-translate/translation/add-missing';
    const pathInternal = '/api/translation/add-missing';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.translation !== undefined) {
        body = params.translation;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
addMissingTranslation.paramsOrder = [{ type: 'body', paramName: 'translation' }];
/** Returns all namespace */ export const getNamespaces = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-translate/translations/namespaces';
    const pathInternal = '/api/translations/namespaces';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getNamespaces.paramsOrder = [{ type: 'parameters' }];
export * from './types';
export * from './constants';
